export default "__VITE_ASSET__CtdQHe_N__"